import './Thresholds.css';
export var hasPillThresholds = '_1jrjqrd1-3-5-0';
export var thresholdPill = '_1jrjqrd2-3-5-0';
export var thresholdPillColor = 'var(--_1jrjqrd0-3-5-0)';